import { render, staticRenderFns } from "./companyChoose.vue?vue&type=template&id=d45ed438&scoped=true"
import script from "./companyChoose.vue?vue&type=script&lang=js"
export * from "./companyChoose.vue?vue&type=script&lang=js"
import style0 from "./companyChoose.vue?vue&type=style&index=0&id=d45ed438&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45ed438",
  null
  
)

export default component.exports